import moment from 'moment-timezone';
import { Moment } from 'moment-timezone/moment-timezone';
import {
    GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach
} from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';

/**
 * Sort all the instances map in descent way to have the oldest at the top in coach dashboard
 * @param {Record<String, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach>} initialMap 
 * @param {GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]} instances 
 * @returns {Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>} 
 */
export const sortInstancesDateMap = (initialMap: Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>, instances: GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]) => {
    const DATE_FORMAT_MAP = 'YYYY-MM-DD';
    const dateMapping = instances.reduce((acc: Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>, instance: GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach) => {
        const dateKey = moment(instance.startDateTime).format(DATE_FORMAT_MAP).toString();
        if (acc[dateKey]) acc[dateKey].push(instance);
        return acc;
    }, initialMap);
    return Object.keys(dateMapping).sort().reduce((acc: Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>, key: string) => {
        acc[key] = dateMapping[key].sort((a, b) => moment(a.startDateTime).diff(moment(b.startDateTime)))
        return acc;
    }, {});
};


/**
 * Create initial date map
 * @param {Moment} startDateTime startDateTime 
 * @param {Moment} endDateTime endDateTime 
 * @returns {Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>} 
 */
export const createInitialDateMap = (startDateTime: Moment, endDateTime: Moment): Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]> => {
    const DATE_FORMAT_MAP = 'YYYY-MM-DD';
    const diffDays = endDateTime.diff(startDateTime, 'days');
    return [...Array(diffDays + 1).keys()].reduce((acc: Record<string, GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[]>, dayNumber) => {
        const daysToAdd = dayNumber ? 1 : dayNumber;
        const dayKey = startDateTime.add(daysToAdd, 'days').format(DATE_FORMAT_MAP);
        acc[dayKey] = [];
        return acc;
    }, {});
};